export const resourcesParams = {
    resources: {
        params: {
            fields: {
                t: "Pressure",
                p: "Temperature",
                value_date: "Date",
                powerstate: "Battery charge level",
                rssi: "Communication signal level",
            },
        },
    }
}